import { createContext } from 'react'

import noop from 'lib/function/noop'
import type { SvgIconComponent } from 'LuxKit/SvgIcon'

export interface MapLayer {
  id: string
  title: string
  icon?: SvgIconComponent
  isSelected: boolean
  colour?: string
}

export type MapLayerGroupId = 'itinerary' | 'leProducts'

export interface MapLayerGroup {
  id: MapLayerGroupId
  title: string
  selectAllLabel?: string
  selectionStatus: 'all' | 'some' | 'none'
  layers: Array<MapLayer>
}

export interface MapLayersContextValue {
  layerGroups: Array<MapLayerGroup>
  toggleLayer: (group: MapLayerGroupId, id: string) => void
  toggleGroup: (group: MapLayerGroupId) => void
  showAllRoutes: boolean
  toggleShowAllRoutes: () => void
}

const MapLayersContext = createContext<MapLayersContextValue>({
  layerGroups: [],
  toggleLayer: noop,
  toggleGroup: noop,
  showAllRoutes: false,
  toggleShowAllRoutes: noop,
})

export default MapLayersContext
